import { useTranslation } from "react-i18next";
import { Chip, makeStyles, Typography } from "@material-ui/core";
import { formatTokens } from "../helpers";

import { AIModel } from "@dashboard-v3/api";

interface Props {
  model: AIModel;
  isDefault: boolean;
}

export default function ModelOption({ model, isDefault }: Props) {
  const { t } = useTranslation("storage");
  const classes = useStyles();
  const hasContext = model.contextTokens !== undefined;

  return (
    <div className={classes.option}>
      <div className={classes.optionText}>
        <Typography variant="body2" className={classes.optionName}>
          {model.name}
          {isDefault && (
            <Chip
              size="small"
              variant="outlined"
              color="primary"
              className={classes.defaultChip}
              label={t("externalAI.form.defaultModel")}
            />
          )}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {model.id}
        </Typography>
      </div>
      {hasContext && (
        <Typography variant="caption" color="textSecondary" noWrap>
          {t("externalAI.hints.contextShort", {
            amount: formatTokens(model.contextTokens),
          })}
        </Typography>
      )}
    </div>
  );
}

const useStyles = makeStyles({
  option: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    width: "100%",
  },
  optionText: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 0,
  },
  optionName: { fontWeight: 500 },
  defaultChip: { marginLeft: 8, height: 18 },
});
